import styled from 'styled-components'

export const OverflowContainer = styled.div<{ exceedContainer: boolean }>`
  max-width: 1296px;
  margin: 0 auto;
  padding: 0 100px;

  @media (max-width: 768px) {
    padding: 0 0 0 25px;
  }

  ${({ exceedContainer }) =>
    exceedContainer &&
    `
      padding: 0;
      max-width: 1400px;
      @media (max-width: 768px) {
        width: 100vw;
        left: -25px;
        position: relative;
        box-sizing: border-box;
      }
    `}
`
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px 40px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 900px) {
    display: flex;
    white-space: nowrap;
    padding-right: 20px;
    grid-gap: 15px;
  }
`
export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const Nav = styled.svg<{ enabled: boolean }>`
  width: 16px;
  height: 16px;
  cursor: pointer;

  fill: ${({ enabled }) => (enabled ? 'var(--brand-secondary)' : 'grey')};

  @media (max-width: 900px) {
    display: none;
  }
`

export const ProductTileWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  a {
    @media (max-width: 900px) {
      white-space: normal;
    }

    .product-tile__image {
      @media (max-width: 1400px) {
        height: 15vw;
      }
    }

    @media (max-width: 1400px) {
      .product-tile__badges {
        top: auto;
        bottom: calc(100% - 15vw);
      }
    }
    @media (max-width: 768px) {
      .product-tile__image {
        width: 100%;
        min-height: 110px;
      }
      .product-tile__badges {
        bottom: calc(100% - 111px);
        top: auto;
        border-radius: 0 6px 0 0;
        box-sizing: border-box;
        background: white;
        padding: 4px 4px 0 0;
        gap: 4px;

        > div {
          margin: 0;
          gap: 3px;
          font-size: 10px;
        }
      }
    }
  }
`

export const ListNumber = styled.span`
  background: var(--brand-secondary);
  position: absolute;
  top: 8px;
  left: 8px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-align: center;
  color: white;
  z-index: 2;
  line-height: 35px;
  border-radius: 50%;
  font-weight: var(--font-bold);

  @media (max-width: 900px) {
    width: 25px;
    height: 25px;
    font-size: 12px;
  }
`
